import { ReactNode } from "react";
import { MuiThemeProvider } from "../../styles/muiTheme/MuiTheme";
import { darkModeAtom } from "../../atoms/user/darkModeAtom";
import { useAtomValue } from "jotai";

export const MuiProvider = ({ children }: { children: ReactNode }) => {
  const darkMode = useAtomValue(darkModeAtom);
  return <MuiThemeProvider darkMode={darkMode}>{children}</MuiThemeProvider>;
};
